<template>
    <header class="header header-component">
        <div class="actionbar">
            <div class="actionbar--left" v-if="!title">
                <div class="actionbar--logo">
                    <img class="actionbar--logo-img" :src="$img('logo-header.png')" />
                </div>
                <div class="actionbar--brand">
                    <span class="actionbar-text" v-if="!settings.hide_header_companyName"> {{ companyName }} </span>
                </div>
            </div>
            <div class="actionbar--left" v-if="title">
                <svg-item class="backButton" @click.native="onBackClick" size="32" :icon="'volver'"  :color="'--header-fg-color'"></svg-item>
                <div class="actionbar--title">
                    <span class="actionbar-text"> {{ title }} </span>
                </div>
            </div>
            <div class="actionbar--right" v-if="user">
                <div class="actionbar--icons">
                    <dropdown v-if="showDropdownMenu" class="dropdown-right">
                        <template slot="button">
                            <svg-item :color="'--header-fg-color'" :size="22" :icon="'mas-vertical'" :clickeable="true"></svg-item>
                        </template>
                        <ul slot="dropdown-menu" class="dropdown-menu">
                            <li @click.prevent="dropdownAction(item)" v-for="item in computedMenuItems" :key="item.caption">
                                <a href="#">
                                    {{ vm.translate(item.caption) ? vm.translate(item.caption) : item.caption  }}
                                </a>
                            </li>
                        </ul>
                    </dropdown>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { mapGetters } from 'vuex';
import bus from '../../services/bus-event';
import router from '../../router';
import socialShare from '../../cordova/socialShare';
import { openExternalLink } from '../../cordova/InAppBrowser';

export default {
    name: 'header',
    props: {
        title: {
            type: String,
            required: false,
            default: null
        },
        showDropdownMenu: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data () {
        return {
            menuItems: [
                {
                    caption: 'perfil',
                    url: 'profile'
                }, {
                    caption: 'history',
                    url: 'historial'
                }, {
                    caption: 'misReservas',
                    url: 'reservas',
                    visible: () => this.settings.modulo_reserva_de_viajes
                }, {
                    caption: 'promotions',
                    url: 'promotions',
                    visible: () => {
                        return (this.settings.modulo_promociones || this.user.tester) && !this.isDriver;
                    }
                }, {
                    caption: 'currentAccount',
                    url: 'movements',
                    visible: () => {
                        return this.settings.modulo_pagos && this.isDriver;
                    }
                }, {
                    caption: 'compartir',
                    action: () => {
                        this.shareApp();
                    }
                }, {
                    caption: 'toc',
                    url: 'terms'
                }, {
                    caption: 'registrameComoChofer',
                    action: () => {
                        this.register();
                    },
                    visible: () => {
                        return this.settings.modulo_chofer_upgrade && !this.isDriver;
                    }
                }
            ],
            contactoAgregado: false,
            linksMenuAgregados: false,
            vm: this
        };
    },
    computed: {
        ...mapGetters({
            logged: 'auth/checkLogin',
            user: 'auth/user',
            isDriver: 'auth/isChofer',
            settings: 'company/config',
            device: 'cordova/device'
        }),
        companyName () {
            return this.settings && this.settings.nombre ? this.settings.nombre : '';
        },
        companyUrl () {
            return this.settings && this.settings.url ? this.settings.url : '';
        },
        companyShareMessage () {
            return this.settings && this.settings.share_message ? this.settings.share_message : this.translate('compartirMensaje');
        },
        computedMenuItems () {
            return this.menuItems.filter(item => item.visible ? item.visible() : true);
        }
    },
    mounted () {
        this.language = this.$getLang();
        bus.on('back-click', this.onBackClick);
        this.insertContactLink();
    },
    updated () {
        this.insertContactLink();
    },
    methods: {
        dropdownAction (item) {
            if (item.action) {
                item.action();
            }
            if (item.url) {
                this.$router.push(item.url);
            }
        },
        onBackClick () {
            router.back();
        },
        beforeDestroy () {
            bus.off('back-click', this.onBackClick);
        },
        shareApp () {
            let urlShare = this.companyUrl;
            let platform = this.device && this.device.platform ? this.device.platform.toLowerCase() : '';
            if (this.settings.url_share_android && platform.indexOf('android') >= 0) {
                urlShare = this.settings.url_share_android;
            }
            if (this.settings.url_share_ios && platform.indexOf('ios') >= 0) {
                urlShare = this.settings.url_share_ios;
            }
            console.log(urlShare);
            let options = {
                text: this.companyShareMessage, // not supported on some apps (Facebook, Instagram)
                title: this.companyName, // fi. for email
                // files: ['', ''], // an array of filenames either locally or remotely
                url: urlShare,
                dialogTitle: this.translate('compartirApp') // Android only, you can override the default share sheet title
            };
            socialShare.share(options);
        },
        register () {
            if (this.settings.modulo_chofer_upgrade) {
                this.$router.push({name: 'upgrade-chofer'});
            } else {
                openExternalLink(process.env.API_URL + '/registrarme');
            }
        },
        insertContactLink () {
            if (this.settings && this.settings.url_contact_form && !this.contactoAgregado) {
                this.contactoAgregado = true;
                let item = {
                    caption: 'contacto',
                    action: () => {
                        openExternalLink(this.settings.url_contact_form);
                    }
                };
                this.menuItems.splice(3, 0, item);
            }
        },
        insertLinksMenu () {
            console.log('insertLinksMenu', this.settings.links_menu);
            if (this.settings && Array.isArray(this.settings.links_menu) && !this.linksMenuAgregados) {
                this.linksMenuAgregados = true;
                this.settings.links_menu.reverse().forEach((link) => {
                    console.log('link show', !link.show || (this.isDriver && link.show === 'C') || (!this.isDriver && link.show === 'P'));
                    if (!link.show || (this.isDriver && link.show === 'C') || (!this.isDriver && link.show === 'P')) {
                        let item = {
                            caption: link.label,
                            action: () => {
                                if (window.cordova && window.cordova.InAppBrowser) {
                                    window.cordova.InAppBrowser.open(link.url, '_system', 'location=no');
                                } else {
                                    window.open(link.url, '_blank');
                                }
                            }
                        };
                        this.menuItems.splice(4, 0, item);
                    }
                });
            }
        }
    },
    watch: {
        settings: function () {
            this.insertContactLink();
            this.insertLinksMenu();
        }
    }
};
</script>

<style scoped>
.actionbar {
    position: fixed;
    left: 0;
    background: var(--header-bg-color);
    height: var(--header-height) + var(--ios-pad);
    padding-top: var(--ios-pad);
    width: 100%;
    z-index: 2100;
    box-shadow: 0px 1px 5px 3px rgba(153, 153, 153, .4);
    vertical-align: top;
}
.actionbar--left,
.actionbar--right {
    height: 100%;
    display: inline-block;
}

.actionbar--right {
    text-align: right;
    float: right;
    margin-right: 1em;
}

.header:after {
    display: block;
    content: " ";
    height: calc(var(--header-height) + var(--ios-pad));
    width: 100%;
}
.actionbar--logo,
.actionbar--icons,
.actionbar--brand,
.actionbar--title {
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    line-height: var(--header-height);
}
.actionbar--logo-img {
    width: 42px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 1em;
}
.actionbar--icons {
    display: inline-block;
}
.actionbar--brand,
.actionbar--title {
    color: var(--header-fg-color);
}
.actionbar-text {
    font-weight: bold;
    margin-left: .4em;
    font-size: 1.6em;
}
.backButton {
    margin-left: 1em;
    cursor: pointer;
}
.actionbar--title .actionbar-text {
    font-weight: 400;
}
</style>

<style>
.app-container {
    min-height: calc(100vh - var(--header-height) - var(--ios-pad));
}
</style>



// WEBPACK FOOTER //
// src/components/sections/Header.vue